import React, { useEffect, useState } from "react";
import { Phone, MessageCircle } from "lucide-react";
import { SITE } from "@/lib/site";

export default function FloatingActions() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <div className="fixed bottom-5 left-5 z-40 flex flex-col gap-3" data-testid="floating-actions">
      <a
        href={`https://wa.me/${SITE.whatsapp}`}
        target="_blank"
        rel="noreferrer"
        data-testid="floating-whatsapp"
        className="w-14 h-14 rounded-full flex items-center justify-center shadow-xl hover:scale-105 transition-transform"
        style={{ backgroundColor: "#4ea83a" }}
        aria-label="WhatsApp"
      >
        <MessageCircle className="w-6 h-6 text-white" />
      </a>
      <a
        href={`tel:${SITE.phoneE164}`}
        data-testid="floating-call"
        className="w-14 h-14 rounded-full flex items-center justify-center shadow-xl hover:scale-105 transition-transform bg-white ring-1 ring-slate-200"
        aria-label="Anrufen"
      >
        <Phone className="w-6 h-6" style={{ color: "#1e3a5f" }} />
      </a>
    </div>
  );
}
